import { render, staticRenderFns } from "./CategorySelector.vue?vue&type=template&id=897249ec&scoped=true&"
import script from "./CategorySelector.vue?vue&type=script&lang=js&"
export * from "./CategorySelector.vue?vue&type=script&lang=js&"
import style0 from "./CategorySelector.vue?vue&type=style&index=0&id=897249ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897249ec",
  null
  
)

export default component.exports